const FEATURED_BANNER_DISMISS_KEY = 'disgenet-tools-featured-dismissed';

export function readDismissedFeaturedToolId(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(FEATURED_BANNER_DISMISS_KEY);
  } catch {
    return null;
  }
}

export function dismissFeaturedTool(toolId: string): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(FEATURED_BANNER_DISMISS_KEY, toolId);
}
